import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useParams } from 'react-router-dom';

import { matchConsolidationDetailRoutePath } from '@futrli/shared-services';
import { useApiView } from '@futrli/views/hooks/useApiView';
import { ReportTemplatesListView } from '@futrli/views/views/reports/ReportTemplatesListView/ReportTemplatesListView';

export const useReportTemplates = () => {
  const flags = useFlags();
  const { workspaceId = '', organisationId = '' } = useParams();
  const isConsolidation = !!matchConsolidationDetailRoutePath(window.location.pathname);

  const view = useApiView(
    useMemo(() => new ReportTemplatesListView(workspaceId, organisationId, isConsolidation, flags), [
      flags,
      workspaceId,
      organisationId,
      isConsolidation
    ])
  );

  const workspaceTemplates = view.state.workspaceReportTemplates ?? [];

  return {
    workspaceTemplates,
    isLoading: view.state.isLoading,
    errorLoading: view.state.errorLoading,
    isResourceSharingEnabled: !!flags.resourceSharing
  };
};
